<div>
  <app-header></app-header>

  <div class="">
    <router-outlet></router-outlet>
  </div>

  <app-footer class="mt-auto"></app-footer>
</div>
